import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HTMLRenderer from "../../../components/HtmlRendering";
import { Stack, Typography } from "@mui/material";

const CardActiveCorporate = ({ variant, user_role, item }) => {
    const secureThumbnail =
        item?.thumbnail_url?.startsWith("http://")
            ? item?.thumbnail_url.replace("http://", "https://")
            : item?.thumbnail_url;
    const [hide, setHide] = useState(true);
    const navigate = useNavigate();

    const handleOpenConsole = (id) => {
        const hasVM = item?.VM_access;
        const hasTTX = item?.ttx_access;

        // only TTX access
        if (!hasVM && hasTTX) {
            navigate(`/scenario-console-ttx/${id}`, {
                state: {
                    scenarioId: item?.id,
                    participantId: item?.participant_id,
                },
            });
            return;
        }


        navigate(`/scenario-console/${id}`, {
            state: {
                scenarioId: item?.id,
                participantId: item?.participant_id,
            },
        });
    };


    const hasVM = item?.VM_access;
    const hasTTX = item?.ttx_access;
    const showTTXOnly = !item?.VM_access && item?.ttx_access;



    return (
        <Stack

            direction="row"
            style={{
                maxHeight: "fit-content",
                justifyContent: "space-between",
                width: "100%",
                gap: 24,
                backgroundColor: "#16181F",
                borderRadius: "12px",
                marginBottom: 24,
                filter: item?.display === false && `blur(0.8px)`,
            }}
        >

            <Stack direction="row">
                {/* image */}
                <img
                    // src={secureThumbnail}
                    src={item?.thumbnail_url}
                    alt="image"
                    style={{
                        height: "170px",
                        aspectRatio: 2 / 3,
                        borderRadius: "12px 0 0 12px",
                        objectFit: "cover",
                        width: '255px'
                    }}
                />

                {/* details */}
                <Stack
                    justifyContent="space-around"
                    style={{ padding: 12 }}
                    width="100%"
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={2}
                        marginVertical={2}
                        flexWrap="wrap"
                    >
                        <Typography variant="h2">{item?.name}</Typography>

                        <Typography
                            variant="body3"
                            sx={pillStyle}
                        >
                            {item?.severity_name}
                        </Typography>

                        <Typography
                            variant="body3"
                            sx={pillStyle}
                            noWrap
                        >
                            {item?.points} points
                        </Typography>

                        <Typography
                            variant="body3"
                            sx={pillStyle}
                            noWrap
                        >
                            {item?.type_name}
                        </Typography>

                        {item?.ttx_enabled && (
                            <Typography
                                variant="body3"
                                sx={pillStyle}
                                noWrap
                            >
                                TTX enabled
                            </Typography>
                        )}


                        {/* {(hasVM || hasTTX) && (
                            <Typography
                                variant="body3"
                                sx={pillStyle}
                                noWrap
                            >
                                {hasVM && hasTTX
                                    ? "VM + TTX Access"
                                    : hasVM
                                        ? "Only VM Access"
                                        : "Only TTX Access"}
                            </Typography>
                        )} */}








                    </Stack>

                    {/* description */}
                    {hide ? (
                        <Stack sx={{ width: "100%" }}>
                            <Typography
                                variant="h5"
                                sx={{
                                    color: "#BCBEC1",
                                    wordBreak: "break-word",
                                }}
                            >
                                {item?.description
                                    ?.replace(/(<([^>]+)>)/gi, "")
                                    .substring(0, 250)}
                            </Typography>

                            <Typography
                                variant="h5"
                                sx={readMoreStyle}
                                onClick={() => setHide(!hide)}
                            >
                                Read More
                            </Typography>
                        </Stack>
                    ) : (
                        <Stack sx={{ width: "100%", wordBreak: "break-word" }}>
                            <HTMLRenderer htmlContent={item?.description} />

                            <Typography
                                variant="h5"
                                sx={readMoreStyle}
                                onClick={() => setHide(!hide)}
                            >
                                Read Less
                            </Typography>
                        </Stack>
                    )}
                </Stack>
            </Stack>

            {/* right button */}
            <Stack
                justifyContent="center"
                alignItems="center"
                paddingRight={3}
            >
                <Typography
                    onClick={() => handleOpenConsole(item?.id)}
                    sx={{
                        cursor: "pointer",
                        height: "fit-content",
                        padding: "4px 16px",
                        margin: "24px",
                        minWidth: "150px",
                        background: "linear-gradient(45deg, rgb(3, 104, 140) 0%, rgb(8, 190, 208) 100%)",
                        borderRadius: "16px",
                        textAlign: "center",
                        color: "rgb(234, 234, 235)",
                    }}
                >
                    Get Console
                </Typography>
            </Stack>
        </Stack >
    );
};

const pillStyle = {
    color: "#BCBEC1",
    backgroundColor: "#242833",
    borderRadius: "16px",
    padding: "4px 16px",
};

const readMoreStyle = {
    cursor: "pointer",
    color: "#0FF",
};

export default CardActiveCorporate;